import React from 'react'
import { H3 } from '../Heading/index'

/**
 * The join gaia plus component
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onJoinButtonClick - The join gaia button event handler
 * @returns {JSX.Element} The join gaia plus component
 */

function GaiaPlusJoin (props) {
  const {
    staticText,
    // onJoinButtonClick,
  } = props

  return (
    <div className="gaia-plus-page__join">
      <div className="gaia-plus-page__join-container">
        <H3>{staticText.get('joinGaiaPlusToday')}</H3>
        { /* TODO */ }
        <div className="gaia-plus-page__join-content"></div>
      </div>
    </div>
  )
}

export default GaiaPlusJoin
